export default __webpack_public_path__ + "static/media/logo-footer-slogan-2023.f501fa3d.svg";